import React from "react";

import {Form} from "react-bootstrap";
import {useTranslation} from "react-i18next";

export default function CardDescription(props) {
    const { t } = useTranslation('translation', { keyPrefix: 'cardDescription' });

    function saveNewDescriptionText(event) {
        props.setNewDescription(event.currentTarget.value)
    }

    function saveNewTitle(event) {
        props.setNewTitle(event.currentTarget.value)

    }

    return (
        <div>
            <Form id={"myCard"}>
                <Form.Group>
                    <Form.Label>{t('cardName')}</Form.Label>
                    <Form.Control
                        readOnly={!props.edit}
                        style={{
                            overflowY: "scroll",
                            backgroundColor: !props.edit ? '#f0f0f5' : "white",
                            marginBottom: "24px"
                        }}
                        as="textarea"
                        placeholder={t('editToSavePlaceholder')}
                        onChange={e => saveNewTitle(e)}
                        value={props.newTitle}
                        onClick={() => {props.setEdit(true)}}
                    />

                    <Form.Label>{t('cardDescription')}</Form.Label>
                    <Form.Control
                        readOnly={!props.edit}
                        style={{
                            minHeight: '200px',
                            overflowY: "scroll",
                            backgroundColor: !props.edit ? '#f0f0f5' : "white",
                            marginBottom: "24px"
                        }}
                        as="textarea"
                        onChange={e => saveNewDescriptionText(e)}
                        value={props.newDescription}
                        onClick={() => {props.setEdit(true)}}
                    />
                </Form.Group>
            </Form>
        </div>
    )
}